import { render, staticRenderFns } from "./AddSubCategory.vue?vue&type=template&id=780c2e1c&scoped=true"
import script from "./AddSubCategory.vue?vue&type=script&lang=js"
export * from "./AddSubCategory.vue?vue&type=script&lang=js"
import style0 from "./AddSubCategory.vue?vue&type=style&index=0&id=780c2e1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780c2e1c",
  null
  
)

export default component.exports